export default __webpack_public_path__ + "static/media/mine.62c7d69a.jpg";